// src/pages/CollaborationPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/CollaborationPage.css';

const CollaborationPage = () => {
  const [redirecting, setRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const dubsadoFormUrl = "https://portal.dubsado.com/public/form/view/6804545f7349c6003a08ce8d";

  useEffect(() => {
    // Start countdown when redirecting is true
    if (redirecting) {
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown(countdown - 1);
        }, 1000);
        return () => clearTimeout(timer);
      } else {
        // Redirect when countdown reaches 0
        window.location.href = dubsadoFormUrl;
      }
    }
  }, [redirecting, countdown, dubsadoFormUrl]);

  const handleContinue = () => {
    setRedirecting(true);
  };

  const handleDirectRedirect = () => {
    window.location.href = dubsadoFormUrl;
  };

  return (
    <div className="collaboration-page">
      <div className="collaboration-hero">
        <div className="container">
          <div className="collaboration-hero-content">
            <div className="logo-mark">L</div>
            <h1 className="collaboration-title">LEGATE<br />COLLABORATION</h1>
            <p className="collaboration-subtitle">Opportunity</p>
          </div>
        </div>
      </div>

      <section className="section collaboration-form-section">
        <div className="container">
          {redirecting ? (
            <div className="redirect-message">
              <div className="redirect-icon">
                <i className="fas fa-sync fa-spin"></i>
              </div>
              <h2>You're being redirected to our collaboration form</h2>
              <p>We're taking you to our secure form in {countdown} seconds...</p>
              <div className="progress-bar">
                <div 
                  className="progress" 
                  style={{ width: `${((5 - countdown) / 5) * 100}%` }}
                ></div>
              </div>
              <p className="small-text">
                If you aren't redirected automatically, 
                <button onClick={handleDirectRedirect} className="text-link">click here</button>
              </p>
            </div>
          ) : (
            <div className="form-card">
              <div className="intro-content">
                <div className="intro-icon">
                  <i className="fas fa-handshake"></i>
                </div>
                <h2>Partner With Us</h2>
                <p>
                  Thank you for your interest in collaborating with Legate! We work with CPAs, Consultants, 
                  Attorneys, and other professionals to provide comprehensive business formation and 
                  compliance services to clients.
                </p>
                <ul className="benefits-list">
                  <li>
                    <span className="checkmark"><i className="fas fa-check"></i></span>
                    Revenue sharing opportunities
                  </li>
                  <li>
                    <span className="checkmark"><i className="fas fa-check"></i></span>
                    Co-marketing capabilities
                  </li>
                  <li>
                    <span className="checkmark"><i className="fas fa-check"></i></span>
                    Client referral program
                  </li>
                  <li>
                    <span className="checkmark"><i className="fas fa-check"></i></span>
                    Professional support network
                  </li>
                </ul>

                <div className="action-buttons">
                  <button onClick={handleContinue} className="btn btn-primary btn-lg">
                    Continue to Collaboration Form
                  </button>
                  <Link to="/" className="btn btn-outline">
                    Back to Home
                  </Link>
                </div>
              </div>
              
              <div className="info-section">
                <h3>What happens next?</h3>
                <ol className="steps-list">
                  <li>
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <p>Complete the collaboration intake form</p>
                    </div>
                  </li>
                  <li>
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <p>Our team reviews your information within 1-2 business days</p>
                    </div>
                  </li>
                  <li>
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <p>We schedule a call to discuss partnership opportunities</p>
                    </div>
                  </li>
                  <li>
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <p>Begin our collaboration partnership</p>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          )}
          
          <div className="trust-badges">
            <div className="trust-badge">
              <i className="fas fa-shield-alt"></i>
              <span>Secure & Confidential</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-check-circle"></i>
              <span>Professional Network</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-bolt"></i>
              <span>Fast Response Time</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CollaborationPage;
